import { createSlice } from "@reduxjs/toolkit";

const statisticsSlice = createSlice({
  name: "statistics",
  initialState: {
    items: [],
  },
  reducers: {
    addItemToList(state, action) {
      const newItem = action.payload;
        state.items.push(newItem);
    },
    clearFavorite(state) {
      state.items = [];
      state.totalQuantity = 0;
    },
  },
});

export const statisticsActions = statisticsSlice.actions;
export default statisticsSlice.reducer;
